/**
 * The six-rung disclosure ladder, as figures S5 and S7 draw it: filled rungs
 * up to the level reached, an amber rung where an NDA gate is waiting, and the
 * rest empty. Identities appear only from rung 4, after a mutual NDA — this
 * component draws the rungs; the caller decides what it is allowed to name.
 */
export const RUNG_COUNT = 6

/** From rung 4 a counterparty may be named — below it, never. */
export const IDENTITY_RUNG = 4

export interface RungMeterProps {
  level: number
  /** Marks the gate rung amber when an NDA is pending at the current level. */
  ndaPending?: boolean
  /** The caption under the rungs, e.g. "rung 4 · NDA gate". */
  caption?: string
}

export default function RungMeter({ level, ndaPending = false, caption }: RungMeterProps) {
  return (
    <div data-part="RungMeter">
      <div className="flex gap-1" aria-label={`rung ${level} of ${RUNG_COUNT}`}>
        {Array.from({ length: RUNG_COUNT }, (_, i) => {
          const filled = i < level
          const gate = ndaPending && i === level
          return (
            <span
              key={i}
              data-testid={gate ? 'rung-gate' : filled ? 'rung-on' : 'rung-off'}
              className={`h-2.5 w-5 rounded-full ${
                gate ? 'bg-amber-400' : filled ? 'bg-iflow-500' : 'bg-gray-200'
              }`}
            />
          )
        })}
      </div>
      {caption && <div className="mt-1 text-[11.5px] text-gray-500">{caption}</div>}
    </div>
  )
}
